
import { PropType, defineComponent } from 'vue';
import AppError, { VuelidateValidation } from '@/components/Error.vue';
import DateTimePicker from '@vuepic/vue-datepicker';

export const DateFormat = {
    yyyyMMdd: 'yyyy/MM/dd HH:mm',
    yyyyddMM: 'yyyy/dd/MM HH:mm',
    MMddyyyy: 'MM/dd/yyyy HH:mm',
    ddMMyyyy: 'dd/MM/yyy HH:mm'
} as const;

export type DateFormatType = typeof DateFormat[keyof typeof DateFormat];

export default defineComponent({
    name: 'AppDateTimePicker',
    components: { AppError, DateTimePicker },
    props: {
        modelValue: { type: Date, default: null },
        validations: { type: Object as PropType<VuelidateValidation>, default: undefined },
        disabled: { type: Boolean, default: false },
        textInput: { type: Boolean, default: true },
        format: { type: String as PropType<DateFormatType>, default: DateFormat.yyyyMMdd }
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        function onValueChange(value: any) {
            emit('update:modelValue', value);

            if (props.validations) {
                props.validations.$touch();
            }
        }

        return { onValueChange };
    }
});
